export const displayScalar = (value: unknown): string | number => {
  if (typeof value === 'string' || typeof value === 'number') return value;
  return '';
};

export const displayAddress = (value: unknown): string => {
  if (
    value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    'address' in value
  ) {
    const address = (value as { address?: unknown }).address;
    return typeof address === 'string' ? address : '';
  }
  return '';
};

export const displayImages = (
  value: unknown
): Array<{ id?: string | number; url?: string }> => {
  return Array.isArray(value) ? value : [];
};

export const checkboxChecked = (value: unknown): boolean => {
  return value === true;
};
